import { Injectable, inject } from '@angular/core';
import { GoogleAuthProvider, User, signInWithPopup } from "firebase/auth";
import { Auth } from '@angular/fire/auth';
import { Store } from '@ngrx/store';
import { Firestore, onSnapshot } from '@angular/fire/firestore';
import { doc } from 'firebase/firestore';
import { BaseState } from '../reducers';
import { UserActions } from '../users/store/user.actions';
import { UserData } from '../users/store/user.reducer';
import { Router } from '@angular/router';
import { GithubAuthProvider, TwitterAuthProvider} from "firebase/auth";
import { MessageService } from 'primeng/api';
import { OAuthProvider } from "firebase/auth"

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  firebaseAuth = inject(Auth)
  firestore = inject(Firestore)

  githubProvider = new GithubAuthProvider();
  googleProvider = new GoogleAuthProvider();
  twitterProvider = new TwitterAuthProvider();

  constructor(
    private store: Store<BaseState>,
    private router: Router,
    private messageService: MessageService
  ){
    this.githubProvider.addScope("read:user")
    this.githubProvider.addScope("user:email")
  }

  async ngOnInit(): Promise<void> {
    await this.firebaseAuth.authStateReady()
    if (this.firebaseAuth.currentUser) {
      this.listenForUserChanges(this.firebaseAuth.currentUser)
    }
  }

  private signIn(provider: OAuthProvider){
    signInWithPopup(this.firebaseAuth, provider)
    .then( async (result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      const credential = GoogleAuthProvider.credentialFromResult(result);
      if (!credential) {
        throw new Error('User login failed');
      }
      const token = credential.accessToken;
      // The signed-in user info.
      const user = result.user;

      this.listenForUserChanges(user)
    }).catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      this.messageService.add({severity: 'error', summary: errorCode, detail: errorMessage});
    });
  }

  loginWithGithub(){
    this.signIn(this.githubProvider as OAuthProvider)
  }

  loginWithGoogle() {
    this.signIn(this.googleProvider as OAuthProvider)
  }

  loginWithTwitter() {
    this.signIn(this.twitterProvider as OAuthProvider)
  }

  listenForUserChanges(user: User){
    onSnapshot(doc(this.firestore, `users`, user.uid), (doc) => {
      this.store.dispatch(UserActions.updateData({data: doc.data() as UserData}))
    })
  }
}
